import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'Back',
  props: {
    // 箭头颜色
    fontColor: {
      type: String,
      default: '#FFF'
    },
    // 背景色块颜色
    bgColor: {
      type: String,
      default: 'rgba(0,0,0,.5)'
    },
    // 是否使用粘性定位
    isSticky: {
      type: Boolean,
      default: false
    },
    // 粘性定位的边界高度
    height: {
      type: Number,
      default: 0
    },
    // 返回事件
    goback: {
      type: Function,
      default: function _default() {
        return window.history.back();
      }
    },
    wxShow: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      scrollFixed: false
    };
  },
  computed: {
    stickyHeight: function stickyHeight() {
      var width = document.body.clientWidth;
      var height = this.height - 40;
      return height * width / 375;
    },
    isFixed: function isFixed() {
      return this.isSticky ? this.scrollFixed : !this.isSticky;
    },
    isHide: function isHide() {
      if (this.$Utils.appInfo) return true;
      if (this.wxShow) return false;
      return !!this.$Utils.wechatInfo();
    },
    canScroll: function canScroll() {
      return this.isSticky && !this.isHide;
    }
  },
  mounted: function mounted() {
    if (this.canScroll) {
      window.addEventListener('scroll', this.handleScroll);
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.canScroll) {
      window.removeEventListener('scroll', this.handleScroll);
    }
  },
  methods: {
    handleScroll: function handleScroll() {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      this.scrollFixed = scrollTop > this.stickyHeight;
    },
    clickEvent: function clickEvent() {
      // 如果是app内直接使用goBackPage返回
      this.$Utils.appInfo ? this.$App.goBackPage() : this.goback();
    }
  }
};